import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am{" "}
            <span className="purple">Akul Gehlot</span> from
            <span className="purple"> Indore, Madhya Pradesh, India.</span>
            <br />
            <br />
            I am a <span className="purple">Java Backend Developer</span> currently
            working at <span className="purple">Procure Tiger Private Limited.</span>,
            where I develop and maintain a large-scale enterprise
            <span className="purple"> e-Procurement platform (ABC Procure)</span>.
            <br />
            <br />
            I specialize in building secure, scalable, and high-performance
            enterprise applications using{" "}
            <span className="purple">
              Java, Spring MVC, Spring Boot, Hibernate, JSP, Servlets, SQL Server,
              MySQL, Maven, Tomcat, Quartz Scheduler, ActiveMQ, and REST APIs
            </span>.
            <br />
            <br />
            My experience includes Tender & Auction Management, Payment Gateway
            Integration, Digital Signatures, Workflow Automation, Document
            Management, Production Support, Performance Optimization, and
            troubleshooting complex legacy enterprise applications.
            <br />
            <br />
            I enjoy solving challenging backend problems, designing clean
            architectures, optimizing database performance, and continuously
            learning modern technologies including
            <span className="purple">
              {" "}Microservices, System Design, Cloud (AWS), Docker, Kubernetes,
              Kafka, and AI/LLM applications.
            </span>
            <br />
            <br />
            Apart from coding, here are a few things I enjoy!
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Exploring New Technologies
            </li>
            <li className="about-activity">
              <ImPointRight /> Building Side Projects
            </li>
            <li className="about-activity">
              <ImPointRight /> Solving Coding Challenges
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs & Documentation
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning System Design & Cloud
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Building scalable software, solving real-world problems, and never
            stopping the learning journey."
          </p>

          <footer className="blockquote-footer">Akul Gehlot</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;